import React from 'react'

import './styles.scss'

const UrlListItem = ({ children }) => {
  return (
    <a className="url-list-item" href={children} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}

export default UrlListItem
